import React from 'react';
import Logs from 'components/Logs';
import { useSelector } from 'react-redux';

const TasksLogs = ({ id }) => {
  const { fetchedUpdateTask } = useSelector((state) => state.tasks || {});

  return (
    <Logs targetId={parseInt(id)} targetType="Task" title="Task logs" refresh={fetchedUpdateTask} />
  );
};

export default TasksLogs;
